"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasketProvider = void 0;
var _hooks = require("../hooks");
const BasketProvider = () => {
  (0, _hooks.useBasketProviderData)();
  return null;
};
exports.BasketProvider = BasketProvider;